import { ThirdPartyScriptData } from './response-data-validator';
import { ThirdPartyScriptDefinition } from './types';
import { ClarityScript } from './scripts/clarity';
import { GTMBodyScript } from './scripts/gtm-body';
import { GTMHeadScript } from './scripts/gtm-head';
export const thirdPartyScriptRegistry = {
  gtm: {
    placement: 'head',
    render: (thirdPartyData: ThirdPartyScriptData) => <GTMHeadScript gtmData={thirdPartyData.gtm} />
  },
  clarity: {
    placement: 'body',
    render: (thirdPartyData: ThirdPartyScriptData) => <ClarityScript clarityData={thirdPartyData.clarity} />
  },
  gtmBody: {
    placement: 'body',
    render: (thirdPartyData: ThirdPartyScriptData) => <GTMBodyScript gtmData={thirdPartyData.gtm} />
  }
} satisfies Record<string, ThirdPartyScriptDefinition>;